import { render, staticRenderFns } from "./ReserveTransactionsTable.vue?vue&type=template&id=0fd9e45a&scoped=true&"
import script from "./ReserveTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./ReserveTransactionsTable.vue?vue&type=script&lang=js&"
import style0 from "./ReserveTransactionsTable.vue?vue&type=style&index=0&id=0fd9e45a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd9e45a",
  null
  
)

export default component.exports